import "core-js/stable";
import "regenerator-runtime/runtime";
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ViewUI from "view-design";
import "view-design/dist/styles/iview.css";
import echarts from "echarts";
Vue.prototype.$echarts = echarts;
Vue.use(ViewUI);

require("./style/common.scss");

import mixins from "./utils/mixins";
Vue.mixin(mixins);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");

// eslint-disable-next-line
var _hmt = _hmt || [];
// const _hmt = _hmt || [];
// eslint-disable-next-line
window._hmt = _hmt; // 必须把_hmt挂载到window下，否则找不到

(function () {
  var hm = document.createElement("script");
  hm.src = "https://hm.baidu.com/hm.js?fa79abfe9ed0d33c3190b689661277fc";
  var s = document.getElementsByTagName("script")[0];
  s.parentNode.insertBefore(hm, s);
})();
